import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';

import { Store } from '@ngrx/store';
import { DocumentViewerActions } from 'projects/semeris/src/store/document-viewer/document-viewer.actions';
import { RootState } from 'projects/semeris/src/store/root-state.model';
import { UserProfileActions } from 'projects/semeris/src/store/user-profile/user-profile.actions';
import { UserProfileSelectors } from 'projects/semeris/src/store/user-profile/user-profile.selectors';

import { ViewerCommand } from '../../../document-viewer/models/document-viewer.models';
import { ProgressIndicatorComponent } from '../../../home/components/progress-indicator/progress-indicator.component';
import { GuidedTourParamsExtended } from '../../../home/models/asset.model';
import { SemerisRoutes } from '../../../shared/constants/routes';
import { FastTooltipDirective } from '../../../shared/directives/fast-tooltip.directive';
import { PermissionsDirective } from '../../../shared/directives/permissions.directive';
import { Permission } from '../../../shared/models/api/permissions.enum';
import { TransactionToLinkPipe } from '../../../shared/pipes/transaction-to-link.pipe';

@Component({
  selector: 'semeris-guided-tours',
  imports: [
    CommonModule,
    TransactionToLinkPipe,
    RouterModule,
    PermissionsDirective,
    MatCheckboxModule,
    FastTooltipDirective,
    ProgressIndicatorComponent,
  ],
  templateUrl: './guided-tours.component.html',
  styleUrls: ['./guided-tours.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidedToursComponent {
  private readonly store = inject<Store<RootState>>(Store);

  public readonly guidedTourParamsExtended = input<GuidedTourParamsExtended>(undefined);

  public readonly completedGuideTours$ = this.store.select(UserProfileSelectors.completedTourIds);

  public readonly SemerisRoutes = SemerisRoutes;
  public readonly Permissions = Permission;

  public startGuidedTourInViewer(tourId: string): void {
    console.log('startGuidedTourInViewer', tourId);
    this.store.dispatch(
      DocumentViewerActions.SendCommand({
        message: {
          commandType: ViewerCommand.StartGuidedTour,
          value: tourId,
        },
      })
    );
  }

  public onCheckChange(tourId: string, event: MatCheckboxChange) {
    this.store.dispatch(
      UserProfileActions.ToggleCompletedTours({
        tourId,
        completed: event.checked,
      })
    );
  }
}
